<template>
  <div class="result-page">
    <div class="result-content">
      <div class="saved-answers">
  <h2  style="color: #fb7e22;">诊断结果</h2>
  
 

  <div v-for="(answer, index) in savedAnswers" :key="index" class="answer-section" v-show="answer.answer !== '否'">
 
    <p class="answer-content"><strong> {{ answer.question }}</strong>{{ answer.answer }}</p>
  </div>

  <p class="answer-content"><strong> 白发分布：</strong>{{ ti4 }}</p>
  <p class="answer-content"><strong> 饮食偏好：</strong>{{ ti18 }}</p>
    <p class="answer-content"><strong> 生活规律：</strong>{{ ti19 }}</p>
</div>
      
      <h2 v-show="hairGradeInfo" style="color: #fb7e22;">{{ hairGradeInfo }}</h2>

      <!-- 体质信息展示 -->
      <div class="constitution-details" v-if="showConstitutionDetails">
        <h2 style="color: #fb7e22;">体质信息</h2>
        <div v-for="(info, idx) in constitutionInfos" :key="idx" class="section">
          <h3 >类型：{{ info.type }}</h3>
          <p><strong>对应白发机制：</strong>{{ info.mechanism }}</p>
          <p><strong>典型症状组合：</strong>{{ info.symptoms }}</p>
          <p><strong>食补调理核心原则：</strong>{{ info.dietPrinciple }}</p>
          <p><strong>科学依据：</strong>{{ info.scientificBasis }}</p>
        </div>
      </div>

      <!-- 食谱信息展示 -->
      <div class="recipe-details" v-if="showRecipeDetails">
        <h2 style="color: #fb7e22;">食谱信息</h2>
        <div v-for="(recipe, idx) in recipeInfos" :key="idx" class="section">
          <h3 >食谱名称：{{ recipe.name }}</h3>
          <p><strong>食材：</strong>{{ recipe.ingredients }}</p>
          <p><strong>做法：</strong>{{ recipe.method }}</p>
          <p><strong>功效：</strong>{{ recipe.effect }}</p>
          <p><strong>科学依据：</strong>{{ recipe.scientificBasis }}</p>
          <p v-if="recipe.note"><strong>注意/禁忌：</strong>{{ recipe.note }}</p>
        </div>
      </div>
      <div class="recipe-details" >
        <h2 style="color: #fb7e22;">通用食谱</h2>
          <!-- <h3 >食谱名称：{{ recipe.name }}</h3> -->
          <p><strong>食材：</strong>黑米30g + 黑豆20g + 黑芝麻15g + 核桃仁10g + 红枣3颗 +桂圆5颗+枸杞 5克</p>
          <p><strong>做法：</strong>黑米、黑豆提前浸泡2小时，加适量水煮至软烂，最后加入黑芝麻、核桃碎和去核红枣，桂圆枸杞焖煮5分钟。 </p>
          <p><strong>功效：</strong>黑色谷物富含铁、锌和维生素E，核桃补充Omega-3，红枣补气血。</p>
          <p><strong>主要：</strong>补肾益精，改善肝肾不足型白发（常见于熬夜、压力大人群）。</p>
      </div>

     
    
     <!-- 外治方案 -->
     <div class="waizhifangan1">
        <h2 style="color: #fb7e22;" >外治方案</h2>
        <div class="section">
          <h3>专属产品方案 + 低强度红外光理疗</h3>
          <p>
            根据白发等级，养发护理师搭配专属产品方案（________）+低强度红外光理疗（调节毛囊生物钟，针对毛囊萎缩者，每周3次）。
          </p>
        </div>

        <div class="section">
          <h3>中药外洗</h3>
          <p>
            每周2次中药外洗：侧柏叶30g + 制何首乌20g 煮水浸泡头皮（促进毛囊血液循环）。
          </p>
        </div>

        <div class="section">
          <h3>穴位按摩</h3>
          <p>每日按压头部经络：三经一脉，七穴（调节气血）</p>
          <ul class="acupoints">
            <li @click="showDetails('三焦经')" title="点击查看详细"><strong>三焦经</strong></li>
            <li @click="showDetails('胆经')" title="点击查看详细"><strong>胆经</strong></li>
            <li @click="showDetails('膀胱经')" title="点击查看详细"><strong>膀胱经</strong></li>
            <li @click="showDetails('督脉')" title="点击查看详细"><strong>督脉</strong></li>
          </ul>
          <table class="acupoint-table">
            <thead>
              <tr>
                <th>穴位名称</th>
                <th>功效</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>浮白穴</td>
                <td>改善白发</td>
              </tr>
              <tr>
                <td>百会穴</td>
                <td>预防白发</td>
              </tr>
              <tr>
                <td>风池穴</td>
                <td>增强营养吸收</td>
              </tr>
              <tr>
                <td>角孙穴</td>
                <td>改善两侧白发</td>
              </tr>
              <tr>
                <td>四神聪</td>
                <td>养发乌发</td>
              </tr>
              <tr>
                <td>少海穴</td>
                <td>增强新陈代谢</td>
              </tr>
              <tr>
                <td>血海穴</td>
                <td>活血养血统血理血</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 核心观点总结 -->
      <div class="core-summary-page1">
        <h2 style="color: #fb7e22;">核心观点总结</h2>
        <div class="summary-content">
          <div class="section">
            <h3>1. 白发本质是综合问题</h3>
            <ul class="summary-list">
              <li>中医：肝肾亏虚、气血不足是内在根源。</li>
              <li>现代医学：黑色素合成障碍（酪氨酸酶活性低）+ 毛囊微循环障碍。</li>
            </ul>
          </div>

          <div class="section">
            <h3>2. 三管齐下”调理原则</h3>
            <ul class="summary-list">
              <li>外养头皮（改善微环境） + 内调肝肾（中医滋补） + 营养支持（抗氧化+矿物质）。</li>
            </ul>
          </div>

          <div class="section">
            <h3>3. 周期与预期</h3>
            <ul class="summary-list">
              <li>坚持3个月可见毛发质地改善，6个月后新生白发减少（需定期复测头皮数据）。</li>
            </ul>
          </div>

          <div class="section">
            <h3>4. 执行原则</h3>
            <ul class="summary-list">
              <li>先修复头皮生态（pH值/微循环正常化） → 再激活黑色素合成 → 最后巩固毛囊健康。</li>
              <li>忌急于求黑：白发转黑需6-12个月周期，但3个月内可见发质增粗、脱发减少。</li>
            </ul>
          </div>

          <div class="section">
            <h3>5. 跟踪复诊机制</h3>
            <table class="follow-up-table">
              <thead>
                <tr>
                  <th>时间</th>
                  <th>检测项目</th>
                  <th>目标改善值</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>30天</td>
                  <td>头皮油脂分泌量、毛囊萎缩率</td>
                  <td>油脂减少20%，毛囊萎缩率下降5%</td>
                </tr>
                <tr>
                  <td>90天</td>
                  <td>白发占比、每日脱发量</td>
                  <td>白发减少10%，脱发量80根/日</td>
                </tr>
                <tr>
                  <td>180天</td>
                  <td>毛囊密度、头皮微生物菌群</td>
                  <td>毛囊密度提升15%，马拉色菌5×10³ CFU/g</td>
                </tr>
              </tbody>
            </table>
           
            
 <!-- 推荐食材与组合 -->
         <div class="core-summary-page1">
        <h2 style="color: #fb7e22; font-size: 24px; margin-bottom: 15px;">营养学协同方案表</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
                <tr style="background: #e0e0e0;">
                    <th style="padding: 10px; border: 1px solid #ddd; color: #333;">问题</th>
                    <th style="padding: 10px; border: 1px solid #ddd; color: #333;">关键营养素</th>
                    <th style="padding: 10px; border: 1px solid #ddd; color: #333;">推荐食材</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="padding: 10px; border: 1px solid #ddd; color: #555;">白发</td>
                    <td style="padding: 10px; border: 1px solid #ddd; color: #555;">铜、酪氨酸</td>
                    <td style="padding: 10px; border: 1px solid #ddd; color: #555;">
                        <ul style=" padding-left: 10px;">
                            <li style="font-weight: 700;">含铜：铜参与铁代谢,抗氧化和神经功能，每日推荐摄入量约0.9mg</li>
                            <li>黑巧克力（70%以上，100g，含铜1.8mg），芝麻(100g含铜1.6mg），腰果（100g含铜2.2mg一日小把即可），牛肝（100g含铜14.3mg），牡蛎（100g含铜7.6mg同时含锌）、杏仁、南瓜子</li>
                            <li style="font-weight: 700;">含铁：铁是血红蛋白核心成分，成年男性需8/mg，女性18/mg</li>
                            <li>蛤蜊（100g含铁28mg，铁含量最高）。猪肝：（100g含铁23mg，建议一周一次）。瘦牛肉（100g含铁3.2mg，搭配彩椒促进吸收）。菠菜（100g含铁2.7mg，焯水去草酸，搭配柠檬汁）豆腐（100g含铁5.4mg，适合素食者）。黑木耳（100g含铁97.4mg，泡发后凉拌）</li>
                            <li style="font-weight: 700;">含络氨酸：络氨酸是合成多巴胺，肾上腺素的前提，每日需约500--1000mg</li>
                            <li>火鸡胸脯（100g含络氨酸1.2g，低脂高蛋白）奶酪（帕玛森）（100g含络氨酸1.8g，少量即可满足需求）大豆（100g含络氨酸1.5g，豆腐豆浆均可）杏仁（100g含1.0g，每日10-15颗）
                              南瓜子（100g含1.3g，零食）鸡蛋（1个鸡蛋含络氨酸250mg，蛋黄为主）三文鱼：(100g含0.9g含Omega-3,促进脑健康）</li>

                            <li style="font-weight: 700;">高效组合1. 补铁组合</li>
                            <li>菠菜炒牛肉：菠菜（铁） + 牛肉（血红素铁） + 红甜椒（维生素C）。</li>
                            <li>蛤蜊豆腐汤：蛤蜊（铁） + 豆腐（铁） + 番茄（维生素C）。</li>
                            <li style="font-weight: 700;">2. 补铜组合</li>
                            <li>藜麦芝麻沙拉：藜麦（铜） + 芝麻（铜） + 橙子（维生素C）。</li>
                            <li>腰果黑巧能量棒：腰果（铜） + 黑巧克力（铜） + 燕麦。</li>
                            <li style="font-weight: 700;">3. 酪氨酸补充组合</li>
                            <li>火鸡三明治：全麦面包 + 火鸡肉（酪氨酸） + 奶酪（酪氨酸）。</li>
                            <li>杏仁奶昔：杏仁（酪氨酸） + 香蕉 + 希腊酸奶（酪氨酸）</li>
                            <li style="font-weight: 700;">注意事项</li>
                            <li>1.铜过量风险：铜摄入上限为10mg/天，过量可能引发恶心、肝损伤（避免长期大量吃动物肝脏）。</li>
                            <li>2.铁吸收技巧：植物性铁餐后搭配柑橘类水果（维生素C提升吸收率）；避免与咖啡、茶同食（单宁酸抑制铁吸收）。</li>
                            <li>3.酪氨酸与情绪调节：酪氨酸需在维生素B6、叶酸辅助下合成神经递质，可搭配绿叶菜、鸡蛋。</li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
            <div style="color: #fb7e22; font-size: 14px; margin-bottom: 15px;margin-top: 20px;">      注：此AI智能诊断方案及食谱以中医体质为基础，结合现代营养学精准调理，安全性与有效性兼备。
              同时建议搭配黑密秀特殊膳食（内调）+黑密秀发精华液（外用）及头皮检测服务协同使用</div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "ResultPage",
  data() {
    return {
  
      savedAnswers: "",
      hairDistributionInfo: this.$route.params.hairDistributionInfo || "未提供信息",
      scalpCondition: this.$route.params.scalpCondition || "未提供信息",
      dandruffInfo: this.$route.params.dandruffInfo || "未提供信息",
      sensitiveInfo: this.$route.params.sensitiveInfo || "未提供信息",
      oilContentInfo: this.$route.params.oilContentInfo || "未提供信息",
      hairGradeInfo: this.$route.params.hairGradeInfo || "未提供信息",
      ti4: this.$route.params.ti4 || "",
      ti18: this.$route.params.ti18 || "",
      ti19: this.$route.params.ti19 || "",

      // 新增：接收选中的体质评定数量
      selectedConstitutionsCount: Number(this.$route.params.selectedConstitutionsCount) || 0,

      // 动态生成的体质信息和食谱信息
      constitutionInfos: [],
      recipeInfos: [],

      showModal: false,
      selectedAcupoint: "",
    };
  },
  computed: {
    showConstitutionDetails() {
      return this.selectedConstitutionsCount > 0;
    },
    showRecipeDetails() {
      return this.selectedConstitutionsCount > 0;
    },
  },
  created() {
    this.savedAnswers= this.$route.params.savedAnswers || [], // 接收保存的答案
    this.selectedConstitutions = this.$route.params.selectedConstitutions || [];
    console.log("lalallala",  this.savedAnswers);
    this.generateConstitutionAndRecipeInfo();
  },
  methods: {
    showDetails(acupoint) {
      this.selectedAcupoint = acupoint;
      this.showModal = true;
    },
    generateConstitutionAndRecipeInfo() {
      const constitutionMap = [
        {
          type: "气虚质",
          mechanism: "气血生化不足 → 毛囊供血供氧不足 → 黑色素合成受阻",
          symptoms: "白发细软 + 易疲劳/气短 + 舌淡有齿痕 + 脉弱",
          dietPrinciple: "滋阴，补气生血养血，健运脾胃 益肺",
          scientificBasis: "血清总蛋白↓，血红蛋白↓，毛囊细胞ATP合成不足（《J Investig Dermatol》2021）",
        },
        {
          type: "血虚质",
          mechanism: "心悸气短→毛囊周围血管密度↓25%→皮肤干燥→白发早生",
          symptoms: "白发早生+失眠多梦+手足发麻+舌细长",
          dietPrinciple: "检测提示缺铁时，优先补充血红素铁而非单纯食补",
          scientificBasis: "B族维生素（全谷物）+ 铜元素（贝类）维持毛囊代谢，临床数据每日补充B12 2.4μg可使白发逆转率提高37%（《老年医学杂志》2020）",
        },
        {
          type: "阴虚质",
          mechanism: "肝肾阴虚 → 精血亏虚 → 毛发失润 → 早白",
          symptoms: "白发干枯易断 + 五心烦热 + 舌红少苔 + 脉细数",
          dietPrinciple: "滋阴降火，补肾填精，益髓",
          scientificBasis: "血清SOD（抗氧化酶）活性↓，毛囊氧化应激↑（《Oxid Med Cell Longev》2022）",
        },
        {
          type: "阳虚质",
          mechanism: "肾阳虚衰 → 温煦失职 → 毛囊代谢率降低 → 酪氨酸酶活性下降",
          symptoms: "白发枯槁 + 畏寒肢冷 + 腰膝酸软 + 舌胖嫩苔白滑",
          dietPrinciple: "温补肾阳，活血，散寒通络",
          scientificBasis: "甲状腺功能减退（TSH↑），毛囊线粒体功能减弱（《Endocrinology》2020）",
        },
        {
          type: "湿热质",
          mechanism: "湿热熏蒸 → 毛囊炎症 → 黑色素细胞损伤",
          symptoms: "白发伴头皮红斑/瘙痒 + 口苦黏腻 + 舌红苔黄腻 + 脉滑数",
          dietPrinciple: "清热利湿，凉血解毒 健脾祛浊",
          scientificBasis: "IL-6、TNF-α等炎性因子↑，毛囊干细胞NF-κB通路激活（《Front Immunol》2021）",
        },
        {
          type: "痰湿质",
          mechanism: "脾虚湿困 → 痰阻毛窍 → 毛囊缺氧 → 黑色素细胞凋亡",
          symptoms: "白发伴头皮红斑/瘙痒 + 口苦黏腻 + 舌红苔黄腻 + 脉滑数",
          dietPrinciple: "健脾化痰，透窍通络，健脾利水",
          scientificBasis: "头皮马拉色菌过度增殖（真菌培养+），毛囊皮脂腺单位PPARγ信号通路抑制（《J Dermatol Sci》2023）",
        },
        {
          type: "血瘀质",
          mechanism: "气血瘀滞 → 毛囊微循环障碍 → 营养输送受阻",
          symptoms: "白发区域固定 + 面色晦暗 + 舌质紫暗/瘀斑 + 脉涩",
          dietPrinciple: "活血化瘀，行气通滞 ，改善微循环",
          scientificBasis: "全血粘度↑，毛乳头细胞VEGF表达↓（《Microvasc Res》2020）",
        },
        {
          type: "气郁质",
          mechanism: "肝郁气滞 → 疏泄失常 → 毛囊周期性生长紊乱",
          symptoms: "两鬓 突发性白发 + 胸胁胀痛 + 舌边尖红 + 脉弦",
          dietPrinciple: "疏肝解郁，调节神经内分泌，活血通络",
          scientificBasis: "皮质醇↑，毛囊生长周期（Anagen-Catagen转化）异常（《Psychoneuroendocrinology》2019）",
        },
        {
          type: "特禀质",
          mechanism: "免疫紊乱 → 毛囊局部自身免疫攻击 → 黑色素细胞破坏",
          symptoms: "白发伴斑秃 + 过敏史 + 舌淡红苔薄白 + 脉浮",
          dietPrinciple: "调节免疫，抗过敏",
          scientificBasis: "抗黑色素细胞抗体（+），Th1/Th2细胞失衡（《Autoimmun Rev》2022）",
        },
        {
          type: "平和质",
          mechanism: "偶见白发多因外因（日晒/染烫）或自然衰老",
          symptoms: "散在少量白发 + 体健 + 舌淡红苔薄白 + 脉和缓",
          dietPrinciple: "预防氧化损伤，减缓衰老",
          scientificBasis: "端粒酶活性↓，毛囊干细胞端粒缩短（《Nature Aging》2023）",
        },
      ];

      const recipeMap = [
        {
          name: "黄芪黑豆乌鸡汤",
          ingredients: "乌鸡半只、黑豆50g、黄芪20g、红枣5颗、生姜3片",
          method: "乌鸡焯水后与食材同炖2小时，加盐调味。",
          effect: "黄芪补气，黑豆补肾乌发，改善气血不足型脱发。",
          scientificBasis: "黑豆含大豆异黄酮、铁，促进毛囊微循环；黄芪多糖增强免疫力。",
        },
        {
          name: "当归枸杞红枣粥",
          ingredients: "糯米100g、当归10g（纱布包）、枸杞15g、红枣8颗、红糖适量",
          method: "糯米与当归同煮至软烂，加入枸杞、红枣再煮10分钟。",
          effect: "当归补血活血，枸杞滋肝肾，改善血虚白发。",
          note: "湿热体质慎用。",
        },
        {
          name: "黑芝麻桑葚山药粉",
          ingredients: "黑芝麻50g、桑葚干20g、山药粉30g、蜂蜜适量",
          method: "黑芝麻炒香后与桑葚、山药粉打粉，沸水冲泡搅拌。",
          effect: "桑葚滋阴，黑芝麻补肾乌发，缓解阴虚火旺型白发。",
          scientificBasis: "黑芝麻富含维生素E、亚油酸，抗氧化护发。",
        },
        {
          name: "核桃杜仲羊肉汤",
          ingredients: "羊肉300g、核桃仁30g、杜仲10g、生姜5片",
          method: "羊肉焯水后与食材同炖，加黄酒去腥。",
          effect: "杜仲温补肾阳，核桃健脑生发，改善阳虚脱发。",
          note: "湿热体质忌食。",
        },
        {
          name: "薏米赤小豆冬瓜汤",
          ingredients: "薏米30g、赤小豆30g、冬瓜200g、茯苓15g",
          method: "薏米赤小豆浸泡后煮30分钟，加冬瓜再煮15分钟。",
          effect: "清热利湿，减少头皮油脂分泌，防脱发。",
          scientificBasis: "薏米中的薏苡仁酯可抑制皮脂过度分泌。",
        },
        {
          name: "山楂荷叶茶",
          ingredients: "干山楂10g、荷叶5g、陈皮3g",
          method: "沸水冲泡代茶饮，每日1剂。",
          effect: "化痰降脂，改善痰湿阻滞型脱发。",
          note: "胃酸过多者减少山楂用量。",
        },
        {
          name: "玫瑰佛手茶",
          ingredients: "玫瑰花5朵、佛手片5g、红枣3颗（去核）",
          method: "沸水冲泡，闷10分钟后饮用。",
          effect: "疏肝理气，缓解压力性白发、斑秃。",
          scientificBasis: "玫瑰花挥发油调节神经内分泌。",
        },
        {
          name: "三七丹参炖瘦肉",
          ingredients: "猪瘦肉200g、三七粉3g、丹参10g、红枣2颗",
          method: "瘦肉焯水后与药材炖1.5小时，喝汤食肉。",
          effect: "活血化瘀，改善血瘀型脱发（如斑秃）。",
          note: "孕妇禁用，月经期停用。",
        },
        {
          name: "黑豆核桃粥",
          ingredients: "黑豆30g、核桃仁15g、紫米20g、黑芝麻10g、冰糖5克",
          method: "黑豆浸泡4小时以上（促进皂苷溶出），慢煮1.5小时，关火前10分钟加入核桃仁。",
          effect: "黑芝麻中的芝麻素提升TRP-1酶活性（浓度0.05mg/mL时效率达68%）。",
          scientificBasis: "异黄酮通过激活Wnt/β-catenin通路促进毛乳头干细胞分化（《分子营养学》2021）。",
        },
        {
          name: "抗敏三宝粥",
          ingredients: "紫苏叶5g、生姜3片、山药50g、燕麦30g、蜂蜜10ml",
          method: "紫苏叶、生姜煎煮15分钟取汁，放入山药切块与燕麦文火同炖40分钟，关火前5分钟加入蜂蜜拌匀。",
          effect: "山药黏液蛋白修复肠黏膜屏障（动物实验显示结肠杯状细胞数量增加42%）。",
          scientificBasis: "迷迭香酸抑制IL-4/IL-13分泌（体外实验显示浓度10μM时Th2细胞分化减少58%）。β-葡聚糖激活TLR2/4受体增强免疫耐受（临床研究显示IgE水平下降37%）。",
        },
      ];

      // 清空之前的数据
      this.constitutionInfos = [];
      this.recipeInfos = [];

   // 遍历所有选中的体质评估项
   this.selectedConstitutions.forEach(selected => {
      // 解析字符串获取最后一位数字（体质类型ID）
      const parts = selected.split(',');
      const typeId = parseInt(parts[parts.length - 1]);

      // 添加体质信息（根据typeId从map中查找）
      if (!isNaN(typeId) && typeId >= 0 && typeId < constitutionMap.length) {
        this.constitutionInfos.push(constitutionMap[typeId]);
      }

      // 添加食谱信息（根据typeId从map中查找）
      if (!isNaN(typeId) && typeId >= 0 && typeId < recipeMap.length) {
        this.recipeInfos.push(recipeMap[typeId]);
      }
    });
  }}
};
</script>
<style>
.result-page {
  background-color: #f7f7f7;
  padding: 20px;
}

.custom-nav-bar {
  text-align: center;
  width: 100%;
  align-content: center;
  height: 45px;
  color: #000;
  line-height: 45px;
  font-size: 18px;
  font-weight: bold;
}

.result-content {
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  border-radius: 10px;
  margin-top: 10px;
  max-height: 80vh;
  overflow-y: auto;
}

.result-content::-webkit-scrollbar {
  width: 8px;
}

.result-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
}

.result-content::-webkit-scrollbar-track {
  background-color: #f7f7f7;
}

.result-content p {
  margin-bottom: 15px;
  font-size: 16px;
  line-height: 1.5;
}

.waizhifangan {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  text-align: center;
  color: #333;
}

.section {
  margin-bottom: 20px;
}

.section + .section {
  margin-top: 30px;
}

.acupoints {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 10px;
}

.acupoints li {
  background: #f0f0f0;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.acupoints li:hover {
  background: #fb7e22;
  color: white;
}

.acupoint-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 20px;
}

.acupoint-table th,
.acupoint-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.acupoint-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

@media (max-width: 600px) {
  .custom-nav-bar {
    font-size: 16px;
    line-height: 40px;
  }

  .result-content p {
    font-size: 14px;
  }

  .acupoint-table th,
  .acupoint-table td {
    padding: 6px;
  }
}

/* 核心总结 */
.core-summary-page {
  background-color: #f7f7f7;
  padding: 20px;
}

.custom-nav-bar {
  text-align: center;
  width: 100%;
  height: 45px;
  background-color: #fb7e22;
  color: white;
  line-height: 45px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 5px;
}

.summary-content {
  background-color: white;
  border-radius: 10px;
  margin-top: 10px;
  max-height: 80vh;
}

.summary-content::-webkit-scrollbar {
  width: 8px;
}

.summary-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
}

.summary-content::-webkit-scrollbar-track {
  background-color: #f7f7f7;
}

.section {
  margin-bottom: 20px;
}

.section h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.summary-list {
  list-style: none;
  padding: 0;
}

.summary-list li {
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 1.5;
}

.summary-list li strong {
  color: #fb7e22;
}

.follow-up-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.follow-up-table th,
.follow-up-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.follow-up-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

@media (max-width: 600px) {
  .custom-nav-bar {
    font-size: 16px;
    line-height: 40px;
  }

  .summary-content p,
  .summary-list li {
    font-size: 14px;
  }

  .follow-up-table th,
  .follow-up-table td {
    padding: 6px;
  }
}


</style>